<section class="popup-page" [attr.aria-busy]="isSubmitting">
  <header>
    <button type="button" class="icon-button" (click)="!isSubmitting && backRequested.emit()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ name }}</span>
      <h2>{{ 'PROFILE_POPUP_CONFIRM_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [disabled]="isSubmitting" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <p class="subtitle">{{ 'PROFILE_POPUP_REVIEW_USER_INFORMATION_ACCESS' | translate }}</p>

  <div class="content">
    <div class="section-header"><h3>{{ 'PROFILE' | translate }}</h3></div>
    <dl class="card">
      <div class="row-item"><dt>{{ 'NAME' | translate }}</dt><dd>{{ name }}</dd></div>
      <div class="row-item"><dt>{{ 'EMAIL' | translate }}</dt><dd>{{ email }}</dd></div>
      <div class="row-item"><dt>{{ 'PHONE' | translate }}</dt><dd>{{ formattedPhone }}</dd></div>
      <div class="row-item"><dt>{{ 'PROFILE_POPUP_NOTE' | translate }}</dt><dd>{{ profileDetails?.notes || ('PROFILE_POPUP_NOT_SET' | translate) }}</dd></div>
    </dl>
    <dl class="card type-card"><div class="row-item"><dt>{{ 'USER_TYPE' | translate }}</dt><dd>{{ profileDetails?.userType }}</dd></div></dl>

    <div class="section-header">
      <h3>{{ 'PROFILE_POPUP_ACCESS' | translate }}</h3>
      <button type="button" class="link-button" (click)="viewAll()" [disabled]="!accesses.length">{{ 'VIEW_ALL' | translate }}</button>
    </div>
    <div *ngIf="timeSummary || daysSummary" class="time-summary">
      <p><mat-icon aria-hidden="true">calendar_today</mat-icon><span><strong>{{ timeSummary }}</strong><strong *ngIf="daysSummary">{{ daysSummary }}</strong></span></p>
    </div>
    <div class="time-zone" *ngIf="timeZone"><img src="assets/svg/ico-vector-globe.svg" alt="" aria-hidden="true" /><strong>{{ timeZone }}</strong></div>
    <p *ngIf="!accesses.length" class="empty">{{ 'PROFILE_POPUP_NO_ACCESS_DETAILS' | translate }}</p>
    <ul class="access-list">
      <li *ngFor="let access of accesses; let i = index" class="access-card">
        <button type="button" class="access-header" (click)="toggleAccess(access)" [attr.aria-expanded]="isExpanded(access)">
          <span class="unit-icon" aria-hidden="true"><img src="assets/svg/ico-default-home.svg" alt="" /></span>
          <span class="access-name">{{ access.unitName || access.entityName || access.accessPointName }}</span>
          <mat-icon aria-hidden="true">{{ isExpanded(access) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <div *ngIf="isExpanded(access)" class="access-detail">
          <img src="assets/svg/ico-building-gray.svg" alt="" aria-hidden="true" />
          <span><strong>{{ access.buildingName }}</strong><small>{{ access.floorName }}<ng-container *ngIf="access.entityName">, {{ access.entityName }}</ng-container></small></span>
        </div>
      </li>
    </ul>
  </div>

  <p *ngIf="errorKey" class="error" role="alert">{{ errorKey | translate }}</p>
  <p *ngIf="isSubmitting" class="loading" role="status">{{ 'PROFILE_POPUP_SENDING_INVITE' | translate }}</p>
  <button type="button" class="primary-button" [disabled]="!canInvite" [attr.aria-busy]="isSubmitting" (click)="sendInvite()">{{ 'PROFILE_POPUP_CONFIRM_ACCESS' | translate }}</button>
</section>
